import { useState, useContext, useEffect } from 'react';
import { ModalContext } from '../../components/contexts';
import { useNavigate, useLocation } from 'react-router-dom';
import { isValidEmail } from '../../services/UtilService';
import { nlPost } from '../../apis/notLoginApi';

const JoinEmlChk = () => {
  useEffect(() => {
    document.title = '중복 이메일 체크';
  }, []);
  const { modalService } = useContext(ModalContext);
  const [formData, setFormData] = useState({
    userEml: '',
  });

  const [mode, setMode] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state && location.state.mode) {
      setMode(location.state.mode);
    }
  }, [location.state]);

  const handleInputChange = e => {
    const { id, value } = e.target;

    // 한글 입력 방지
    const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value);
    if (isKorean) {
      return;
    }

    // 특수기호 제외 (@와 .은 허용)
    const isSpecialChar = /[^a-zA-Z0-9@.]/.test(value);
    if (isSpecialChar) {
      return;
    }

    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  // const handleInputChange = e => {
  //   const { id, value } = e.target;

  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     [id]: value,
  //   }));
  // };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  // 유효성 검사 후
  const handleValidateAndCheck = async () => {
    const isValid = await fnValidateEmail(formData.userEml);
    if (isValid) {
      getEmlData();
    }
  };

  const fnValidateEmail = async email => {
    if (!isValidEmail(email)) {
      modalService.errorAlert('이메일 형식이 아닙니다.');
      setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
      return false;
    } else {
      return true;
    }
  };

  const getEmlData = () => {
    const url = '/member/duplicateUserEmlChk.do';
    const param = { userEml: formData.userEml };
    nlPost(url, param)
      .then(response => {
        if (response) {
          modalService.successAlert('사용 가능한 이메일 주소입니다.', () => {
            if (mode === 'gen') {
              navigate('/member/joinTerms', {
                state: { mode: mode, userEml: formData.userEml },
              });
            } else if (mode === 'expt') {
              navigate('/member/joinTermsEnt', {
                state: { mode: mode, userEml: formData.userEml },
              });
            }
          });
        } else {
          modalService.errorAlert('사용 불가능한 이메일 주소입니다.', () => {
            setFormData(prevFormData => ({
              ...prevFormData,
              userEml: '',
            }));
          });
        }
      })
      .catch(error => {});
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 가입</h2>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">2단계 현재단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">3단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">4단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">5단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <h3 className="content-tit">중복가입 확인</h3>
      <p className="text-gray-70">
        중복가입 확인을 위해 이메일 주소를 확인하신 후 사용자 가입을 진행하실 수
        있습니다.
      </p>

      <div className="txt-box bg-white gap-md">
        <fieldset>
          <legend>중복가입 확인 폼</legend>
          <div className="form-group">
            <div className="form-tit">
              <label htmlFor="userEml">이메일 주소</label>
            </div>
            <div className="form-conts">
              <div className="input-group">
                <input
                  type="text"
                  id="userEml"
                  className="form-control"
                  value={formData.userEml || ''}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                  onPaste={handlePaste} // 아이디 붙여넣기 금지
                  maxLength={50}
                  aria-labelledby="userEml"
                />

                <button
                  type="button"
                  className="btn secondary"
                  onClick={() => {
                    handleValidateAndCheck();
                  }}
                >
                  중복 확인
                </button>
              </div>
            </div>
            {/*  <p className="text-point">유효성 검사 텍스트 유효성 검사 텍스트 유효성 검사 텍스트</p> */}
          </div>
        </fieldset>
      </div>
    </>
  );
};

export default JoinEmlChk;
